module.exports = __webpack_public_path__ + "static/media/piyush-goel-01.2b41668d.jpg";